import currencyCodes from "currency-codes";
import getSymbolFromCurrency from "currency-symbol-map";

export const currencyOptions = currencyCodes.data.map((currency) => ({
  value: currency.code,
  label: `${getSymbolFromCurrency(currency.code) || ""} ${currency.currency} (${currency.code})`,
  symbol: getSymbolFromCurrency(currency.code) || "",
}));